module.exports = __webpack_public_path__ + "img/lang-icon.ccb94e4f.svg";